export const SHOW_UNAVAILABLE_ITEM_MODAL = 'SHOW_UNAVAILABLE_ITEM_MODAL';
export const SHOW_SB_TRADE_ONBOARDING = 'SHOW_SB_TRADE_ONBOARDING';

export const UNAVAILABLE_ITEM_PRIORITY = 500;
export const UNAVAILABLE_ITEM_COOKIE_KEY = 'trans_unavailableItem';
export const UNAVAILABLE_ITEM_NOTIFICATION_KEY = 'unavailableItem';

export const SB_TRADE_ONBOARDING_PRIORITY = 350;
export const SB_TRADE_ONBOARDING_NOTIFICATION_KEY = 'sbTradeOnboarding';
